import { render, staticRenderFns } from "./C-InfoOther.vue?vue&type=template&id=704daf31&scoped=true&"
import script from "./C-InfoOther.vue?vue&type=script&lang=js&"
export * from "./C-InfoOther.vue?vue&type=script&lang=js&"
import style0 from "./C-InfoOther.vue?vue&type=style&index=0&id=704daf31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704daf31",
  null
  
)

export default component.exports